export interface IPreSelectHistory {
    centerId: number,
    centerAlias: string,
    adjustedComplianceAverage: number,
    preselectReversalCount: number
}
